import { useState } from "react";
import { ContentCopy as ContentCopyIcon } from "../icons";
import { UIIconButton, UITooltip } from "../index";
import { SxProps, Theme } from "@mui/material";

type Props = {
  text: string;
  tooltip?: string;
  disabled?: boolean;
  sx?: SxProps<Theme>;
};

const UICopyIconButton = ({ text, tooltip = "Copy to clipboard", disabled, sx }: Props) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = (e: React.MouseEvent) => {
    e.stopPropagation();
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <UITooltip title={copied ? "Copied!" : tooltip}>
      <span>
        <UIIconButton size="small" onClick={handleCopy} disabled={disabled} sx={{ padding: "2px", ...sx }}>
          <ContentCopyIcon sx={{ fontSize: 14 }} />
        </UIIconButton>
      </span>
    </UITooltip>
  );
};

export default UICopyIconButton;
